import React from 'react';
import { Box } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { Typography } from '../../../ui-kit';

const ShiftInProgress = () => {
    const { t } = useTranslation();

    return (
        <Box
            display='flex'
            justifyContent='center'
            alignItems='center'
            height='100%'
        >
            <Typography
                color='primary'
                variant='h6'
            >
                {t('Shift is still in progress')}
            </Typography>
        </Box>
    );
};

export default ShiftInProgress;
